function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m12 0c-6.628 0-12 5.373-12 12 0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12a12.014 12.014 0 0 0 -.473-3.343.6.6 0 0 0 -1.127.409h-.002c.265.943.402 1.928.402 2.934a10.73 10.73 0 0 1 -3.163 7.637 10.729 10.729 0 0 1 -7.637 3.163 10.73 10.73 0 0 1 -7.637-3.163 10.728 10.728 0 0 1 -3.163-7.637 10.73 10.73 0 0 1 3.163-7.637 10.728 10.728 0 0 1 7.637-3.163c2.576 0 5.013.896 6.958 2.54a1.466 1.466 0 1 0 .862-.84 11.953 11.953 0 0 0 -7.82-2.9zm-1.44 5.88-4.2 10.902h2.63l.687-1.848h3.969l-.719-2.042h-2.613l1.7-4.691 3.024 8.58h2.631l-4.199-10.901z"
});

var SvgApollographql = function SvgApollographql(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApollographql, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "apollographql.svg";
export { ForwardRef as ReactComponent };